/** Consideramos “ida à rede” quando updateToken demora pelo menos isto (ms). */
export const KEYCLOAK_REFRESH_NETWORK_THRESHOLD_MS = 45;

const WINDOW_MS = 60_000;

let networkRefreshTotal = 0;
let totalNetworkDurationMs = 0;
let dedupedJoinTotal = 0;
const recentRefreshTimestamps: number[] = [];

function pruneRecent(now: number): void {
  const cutoff = now - WINDOW_MS;
  while (recentRefreshTimestamps.length > 0 && recentRefreshTimestamps[0]! < cutoff) {
    recentRefreshTimestamps.shift();
  }
}

/** Chamado quando single-flight reutiliza uma Promise de refresh já em voo. */
export function recordKeycloakRefreshDeduped(): void {
  dedupedJoinTotal++;
}

/** Chamado após um updateToken que provavelmente foi à rede (latência alta). */
export function recordKeycloakNetworkRefresh(durationMs: number): void {
  networkRefreshTotal++;
  totalNetworkDurationMs += durationMs;
  const now = Date.now();
  recentRefreshTimestamps.push(now);
  pruneRecent(now);
}

export function getKeycloakRefreshMetricsSnapshot(): {
  networkRefreshTotal: number;
  avgNetworkRefreshMs: number;
  refreshesLast60s: number;
  dedupedJoinTotal: number;
} {
  pruneRecent(Date.now());
  return {
    networkRefreshTotal,
    avgNetworkRefreshMs:
      networkRefreshTotal > 0 ? totalNetworkDurationMs / networkRefreshTotal : 0,
    refreshesLast60s: recentRefreshTimestamps.length,
    dedupedJoinTotal,
  };
}

/** Liga `window.mileKeycloakRefreshMetrics` para debug/observabilidade (só em ambientes que o permitam). */
export function exposeKeycloakRefreshMetricsToWindow(enabled: boolean): void {
  if (typeof window === 'undefined' || !enabled) {
    return;
  }
  (
    window as unknown as {
      mileKeycloakRefreshMetrics: typeof getKeycloakRefreshMetricsSnapshot;
    }
  ).mileKeycloakRefreshMetrics = getKeycloakRefreshMetricsSnapshot;
}
